module.exports = __webpack_public_path__ + "static/img/inspection.4494b6d4.png";